<span class="badge mr-1" [ngClass]="bgStyle"><em class="fa fa-dot-circle mr-1"></em>{{ label | titlecase }}</span>
